export default "__VITE_ASSET__D61ujbRv__"